// extracted by mini-css-extract-plugin
export default {"thumb":"DocumentationPlan_thumb__7EWWB","imageContainer":"DocumentationPlan_imageContainer__1vxjW","imagePreview":"DocumentationPlan_imagePreview__4mk3E"};